import { StoreCRUDModule } from '@/store/assets/StoreCRUDModule';

export default new StoreCRUDModule({ name: 'referencesValues' });
